import { useEffect, useMemo } from 'react'
import { RouterProvider } from '@tanstack/react-router'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { AuthProvider } from './auth/AuthProvider'
import { useAuth } from './auth/useAuth'
import { createAppRouter } from './router'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, staleTime: 30_000 },
  },
})

function AppRouter() {
  const { isAuthenticated, handleCallback } = useAuth()

  // Process OIDC callback when returning from Authentik with ?code=
  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    if (params.has('code')) {
      handleCallback()
    }
  }, [handleCallback])

  const router = useMemo(
    () => createAppRouter({ isAuthenticated }),
    [isAuthenticated],
  )

  return <RouterProvider router={router} />
}

export function App() {
  return (
    <div data-testid="app-root" className="min-h-screen bg-gray-950 text-gray-100">
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </QueryClientProvider>
    </div>
  )
}
